export function showToast(data: any, messageService: any, key?: string) {
  switch (data.type) {
    case 'error':
      errorToast(data.msg, messageService, key);
      break;
    case 'info':
      infoToast(data.msg, messageService, key);
      break;
    case 'warning':
      warningToast(data.msg, messageService, key);
      break;
    case 'success':
      successToast(data.msg, messageService, key);
      break;
    case 'secondary':
      secondaryToast(data.msg, messageService, key);
      break;
  }
}

export function errorToast(
  message: string,
  messageService: any,
  key?: string,
  title?: string,
  sticky?: boolean
) {
  messageService.add({
    severity: 'error',
    summary: title ? title : 'Error',
    detail: message,
    key: key,
    sticky: sticky,
  });
}

export function infoToast(
  message: string,
  messageService: any,
  key?: string,
  sticky?: boolean
) {
  messageService.add({
    severity: 'info',
    summary: 'Information',
    detail: message,
    key: key,
    sticky: sticky,
  });
}

export function warningToast(
  message: string,
  messageService: any,
  key?: string,
  title?: string,
  sticky?: boolean
) {
  messageService.add({
    severity: 'warn',
    summary: title ? title : 'Warning',
    detail: message,
    key: key,
    sticky: sticky,
  });
}

export function successToast(
  message: string,
  messageService: any,
  key?: string,
  title?: string,
  sticky?: boolean
) {
  messageService.add({
    severity: 'success',
    summary: title ? title : 'Success',
    detail: message,
    key: key,
    sticky: sticky,
  });
}

export function secondaryToast(
  message: string,
  messageService: any,
  key?: string,
  sticky?: boolean
) {
  messageService.add({
    severity: 'secondary',
    summary: 'Secondary',
    detail: message,
    key: key,
    sticky: sticky,
  });
}
